import React from "react";

import "./Icon.css";

interface Props {
    className?: string;
}

const IconDrag: React.FC<Props> = function ({ className }: Props) {
    return <i className={`icon icon__drag ${className || ""}`} />;
};

export default IconDrag;
